import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { WtfAnimations } from "../../../../utils/others/core/animations";
import { MenuItem } from "primeng/api";
import { Breadcrumb } from "../../../../utils/types/core/models/breadcrumb";
import { StateService } from "../../../../services/state/state.service";

@Component({
    selector: "wtf-pagelayoutcarded",
    templateUrl: "./pagelayoutcarded.component.html",
    styleUrls: ["./pagelayoutcarded.component.scss"],
    animations: WtfAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class PagelayoutcardedComponent implements OnInit {
    @Input() icon: string;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() routes: Breadcrumb[] = [];

    constructor(private stateService: StateService) {}

    ngOnInit() {}

    get showBreadcrumb(): boolean {
        return this.stateService.showToolbar;
    }
}
